var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPicto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1149,
    height: 1076,
    viewBox: "0 0 1149 1076",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M606.034 0L1030.16 776.335C1030.16 776.335 1141.31 603.114 1064.66 361.617C988.001 120.12 737.616 31.6085 737.616 31.6085C737.616 31.6085 673.741 5.05707 606.034 0Z",
    fill: "#BBBBBB",
    fillOpacity: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.831 0L388.858 213.682L305.819 60.6896C305.819 60.6896 351.809 25.2877 503.831 0Z",
    fill: "#BBBBBB",
    fillOpacity: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.75 13.6738L416.502 264.033L862.346 1075.76H1148.5L555.75 13.6738Z",
    fill: "#BBBBBB",
    fillOpacity: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.302 312.3L259.831 85.9746C259.831 85.9746 61.8192 198.506 19.6615 461.499C-22.4962 724.493 170.407 905.301 170.407 905.301C170.407 905.301 233.004 972.311 322.426 1011.51L446.343 783.917C446.343 783.917 295.6 713.111 278.991 558.855C262.383 404.598 386.302 312.3 386.302 312.3Z",
    fill: "#BBBBBB",
    fillOpacity: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.83 796.564C503.83 796.564 557.485 813.001 648.189 783.92L810.431 1074.73H342.867L503.83 796.564Z",
    fill: "#BBBBBB",
    fillOpacity: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.891 1051.97C296.891 1051.97 179.349 1002.66 96.3128 898.98L0.5 1074.73H287.936L296.891 1051.97Z",
    fill: "#BBBBBB",
    fillOpacity: 0.31
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicto);
export default __webpack_public_path__ + "static/media/picto.861a9c7b5e65589d5cc2d9e16b56be60.svg";
export { ForwardRef as ReactComponent };